<template>
  <v-container class="edit-barrier-page" fluid>
    <v-breadcrumbs :items="breadcrumbs" class="px-0 pt-0 pb-2" />
    <div class="edit-barrier-header">
      <h1 class="edit-barrier-header__title">Редактирование шлагбаума</h1>
      <v-btn
        color="primary"
        outlined
        class="edit-barrier-header__btn text-none"
        dark
        rounded
        @click.prevent="returnBarrier()"
      >
        <v-icon left>mdi-eye-outline</v-icon>
        Просмотр информации
      </v-btn>
    </div>

    <div v-if="Object.keys(barrierEdit).length !== 0" class="edit-barrier-tabs-wrap mt-3">
      <v-tabs v-model="activeTab" class="edit-barrier-tabs" grow show-arrows="mobile">
        <v-tab
          v-for="tab in visibleTabs"
          :key="tab.route"
          class="edit-barrier-tab"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-if="Object.keys(barrierEdit).length !== 0" v-model="activeTab" class="edit-barrier-tabs-items">
      <v-tab-item
        v-for="tab in visibleTabs"
        :key="tab.route"
      >
        <v-card v-if="isDisplayInfoBarrier" class="edit-barrier-block mt-0" flat outlined>
          <div class="edit-barrier-tab-content pa-4">
            <component
              :is="tab.component"
              :returnBarrier="() => returnBarrier()"
            />
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GeneralInfo from './components/GeneralInfo.vue';
import Doors from './components/Doors.vue';

export default {
  name: 'EditBarrier',
  props: ['id'],
  data () {
    return {
      activeTab: 0,
      isDisplayInfoBarrier: false,
      breadcrumbs: [
        { text: 'Шлагбаумы', disabled: false, href: '/barriers' },
        { text: 'Редактирование', disabled: true, href: 'breadcrumbs_link_1' },
      ],
    };
  },
  created () {
    this.isDisplayInfoBarrier = false;
    this.getBarrierInfoEdit({ id: this.id })
      .then(() => {
        this.isDisplayInfoBarrier = true;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке информации');
      });
  },
  computed: {
    ...mapGetters({
      barrierEdit: 'Barriers/barrierEdit',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          component: GeneralInfo,
          route: 'EditBarrierGeneralInfoTab',
          show: true,
        },
        {
          name: 'Двери',
          component: Doors,
          route: 'EditBarrierDoors',
          show: this.barrierEdit.barrier?.physical_status !== 5,
        },
      ];
    },
    visibleTabs () {
      return this.tabs.filter(tab => tab.show && this.$canRoute(tab.route));
    },
  },
  methods: {
    ...mapActions({
      getBarrierInfoEdit: 'Barriers/getBarrierInfoEdit',
    }),
    returnBarriers () {
      this.$router.push({ name: 'Barriers' });
    },
    returnBarrier () {
      this.$router.push({ name: 'DetailBarrier', params: { id: this.$route.params.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-barrier-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.edit-barrier-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.edit-barrier-header__btn {
  text-transform: none;
  font-weight: 500;
}

.edit-barrier-tabs-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px 12px 0 0;
  border-bottom: none;
  overflow: hidden;
}

.edit-barrier-tabs {
  box-shadow: none;
}

.edit-barrier-tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.edit-barrier-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
}

.edit-barrier-tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.edit-barrier-tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.edit-barrier-tabs ::v-deep .v-tabs-bar__prev,
.edit-barrier-tabs ::v-deep .v-tabs-bar__next {
  flex: 0 0 auto;
  min-width: 44px;
}

.edit-barrier-tabs-items {
  background: transparent;
}

.edit-barrier-block {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
}

.edit-barrier-tab-content {
  min-height: 200px;
}

@media screen and (max-width: 600px) {
  .edit-barrier-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .edit-barrier-header__title {
    font-size: 1.4rem;
  }
}
</style>
